


import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addNewMessage, updateMessageStatus } from "../redux/messageSlice";
import { incrementUnreadCount, updateLastMessageTimestamp, updateLastMessageContent } from "../redux/userSlice";

const useGetRealTimeMessage = () => {
    const { socket } = useSelector(store => store.socket);
    const { selectedUser, authUser } = useSelector(store => store.user); 
    const { messages } = useSelector(store => store.message); 
    const dispatch = useDispatch();

    useEffect(() => {
        if (!socket) return;

        const handleNewMessage = (newMessage) => {
            const isFromSelectedUser = newMessage.senderId === selectedUser?._id;
            const isToCurrentUser = newMessage.receiverId === authUser._id;
            const isFromCurrentUser = newMessage.senderId === authUser._id;

             // Check for duplicate message
            const alreadyExists = messages.some(msg => msg._id === newMessage._id);
            if (alreadyExists) return;
            
            // Always update last message info
            dispatch(updateLastMessageTimestamp({
                userId: isFromCurrentUser ? newMessage.receiverId : newMessage.senderId,
                timestamp: newMessage.createdAt
            }));

            dispatch(updateLastMessageContent({
                userId: isFromCurrentUser ? newMessage.receiverId : newMessage.senderId,
                content: newMessage.message
            }));

            // Handle unread counts for incoming messages
            if (isToCurrentUser && !isFromSelectedUser && !isFromCurrentUser) {
                dispatch(incrementUnreadCount({ 
                        senderId: newMessage.senderId,
                        messageId: newMessage._id
                    //timestamp: newMessage.createdAt
                }));
            }

            // Add to messages if:
            // 1. It's from selected user, or
            // 2. It's to selected user, or
            // 3. Admin hasn't selected anyone but received a message
            if (isFromSelectedUser || 
                newMessage.receiverId === selectedUser?._id || 
                // (authUser.isRole === 1 && !selectedUser && isToCurrentUser) ||
                (newMessage.isBroadcastToAdmins && authUser.isRole === 1) ||
                newMessage.senderId === authUser._id ||
                newMessage.receiverId === authUser._id) 
                {
                dispatch(addNewMessage(newMessage));
            }
        };

        const handleMessageDelivered = ({ messageId }) => {
            dispatch(updateMessageStatus({ messageId, status: "delivered" }));
        };

        const handleMessageSeen = ({ messageId }) => {
            dispatch(updateMessageStatus({ messageId, status: "seen" }));
        };

        const handleMessageReplied = ({ messageId, repliedBy, replied,replyMessageId }) => {
            
        
            dispatch(updateMessageStatus({ 
                messageId, 
                 status: "replied", 
                 replied: true,
                 repliedBy ,
               
               
            }));
        };

        socket.on("newMessage", handleNewMessage);
        socket.on("messageDelivered", handleMessageDelivered);
        socket.on("messageSeen", handleMessageSeen);
        socket.on("messageReplied", handleMessageReplied);

        const interval = setInterval(() => {
            if (socket.connected) {
                socket.emit('ping');
            }
        }, 20000);

        return () => {
            socket.off("newMessage", handleNewMessage);
            socket.off("messageDelivered", handleMessageDelivered);
            socket.off("messageSeen", handleMessageSeen);
            socket.off("messageReplied", handleMessageReplied);
            clearInterval(interval);
        };
    }, [socket, dispatch, selectedUser, authUser, messages]);

    return null;
};

export default useGetRealTimeMessage;    